import { ResponseTime } from 'src/types';

export const setNewestValue = (data: ResponseTime[]) => {
    return data.length !== 0 ? data[data.length -1].name : null;
  }


// WEBPACK FOOTER //
// ./src/components/AreaChart/utils/setNewestValue.ts